import { createContext } from "react";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../utils/helpers/constants";
import {
  ICommonQuestion,
  ICommonQuestionsDetails,
} from "../../models/common-question/response";
import { ICommonQuestionsQuery } from "../../models/common-question/query";
import {
  ICreateCommonQuestion,
  IUpdateCommonQuestion,
} from "../../models/common-question/request";

export type CommonQuestionsLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: CommonQuestionsLoading[];

  list?: IBaseListingResponse<ICommonQuestion>;
  query: ICommonQuestionsQuery;

  details?: ICommonQuestionsDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ICommonQuestionsDetails) => void;

    createCommonQuestion: (request: ICreateCommonQuestion) => void;
    updateCommonQuestion: (id: number, request: IUpdateCommonQuestion) => void;
    deleteCommonQuestion: (id: number) => void;
    exportExcel: (data: any) => any;

    setSearch: (search?: string) => void;
    setQuery: (query: ICommonQuestionsQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    exportExcel: DEFAULT_FUNCTION,

    createCommonQuestion: DEFAULT_FUNCTION,
    updateCommonQuestion: DEFAULT_FUNCTION,
    deleteCommonQuestion: DEFAULT_FUNCTION,

    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const CommonQuestionsContext = createContext(externalState);

export default CommonQuestionsContext;
